module.exports = __webpack_public_path__ + "static/media/480.86a23259.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-natural-food/dark/480.png
// module id = 2262
// module chunks = 2